<template>
  <div id="app">
    <fz-header></fz-header>
    <router-view></router-view>
    <fz-footer></fz-footer>
  </div>
</template>

<script>
import FzHeader from "./components/fz-header.vue";
import FzFooter from "./components/fz-footer.vue";
import Store from "./store";

export default {
  name: "app",
  components: {
    FzFooter,
    FzHeader,
  },
  data() {
    return {
      store: Store.state,
    };
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });


    window.myVue = this;
  },
};
</script>

<style>
@import url("./assets/style.less");
#app {
  background-color: rgb(234, 239, 242);
}
a {
  text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
  text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
  text-decoration: none;
}
</style>
